<template>
  <div>
    <el-form label-width="120px" size="mini">
      <el-form-item label="地图中心点坐标">
        <el-input v-model="attribute.center"></el-input>
      </el-form-item>
      <el-form-item label="缩放比">
        <el-input v-model="attribute.zoom"></el-input>
      </el-form-item>
      <el-form-item label="背景颜色">
        <el-select v-model="attribute.mapStyle">
          <el-option
            v-for="(item, index) in list"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "cpt-coordinate-map-option",
  props: { attribute: Object },
  data() {
    return {
      list: [
        {
          label: "默认",
          value: 'normal',
        },
        {
          label: "深色",
          value: 'dark',
        },
        {
          label: "浅色",
          value: 'light',
        },
        {
          label: "清新风格",
          value: 'fresh',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>